function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var COLORS = {
  green: [32, 39],
  cyan: [36, 39],
  magenta: [35, 39],
  bold: [1, 22]
};
export default (function (color, text) {
  if (supportsColor()) {
    var map = COLORS[color];
    return "\x1B[" + map[0] + "m" + text + "\x1B[" + map[1] + "m";
  } else {
    return text;
  }
});
var supportsColor = function supportsColor() {
  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === undefined) {
    if (/^screen|^xterm|^vt100|color|ansi|cygwin|linux/i.test(process.env.TERM)) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};